var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"path"},[_c('span',{staticClass:"item",on:{"click":_vm.back}},[_vm._v("理论考试管理 ")]),_vm._v(" > "),_c('span',{staticClass:"item",on:{"click":_vm.back}},[_vm._v("试卷管理 ")]),_vm._v(" > "),_c('span',{staticClass:"current"},[_vm._v(" "+_vm._s(_vm.currentPath))])])
}
var staticRenderFns = []

export { render, staticRenderFns }